import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton"]
  static values = { fields: Array }

  connect() {
    this.check()
  }

  check() {
    if (!this.hasSubmitButtonTarget) return

    const allFilled = this.fieldsValue.length === 0 ||
      this.fieldsValue.every(name => this.fieldPresent(name))

    this.submitButtonTarget.disabled = !allFilled

    if (allFilled) {
      delete this.submitButtonTarget.dataset.managedDisabled
    } else {
      this.submitButtonTarget.dataset.managedDisabled = "true"
    }
  }

  fieldPresent(name) {
    const elements = this.findFieldElements(name)

    if (elements.length === 0) return true

    const first = elements[0]

    if (first.type === "radio") {
      return elements.some(el => el.checked)
    }

    if (first.type === "checkbox") {
      return elements.some(el => el.checked)
    }

    return (first.value ?? "").toString().trim() !== ""
  }

  findFieldElements(name) {
    const primary = this.element.querySelectorAll(`[name="loan_application[${name}]"]`)
    if (primary.length > 0) return Array.from(primary)

    return Array.from(this.element.querySelectorAll(`[name="${name}"]`))
  }
}
